import React, { FC, useMemo } from 'react';
import { TreeSelection } from '@cubeyou-team/hx-react-components';

import { TaxonomySelectorProps } from './types';
import { getTaxonomyListWithDefault } from './utils';

export const TaxonomySelector: FC<TaxonomySelectorProps> = ({
  taxonomy,
  selectedOptionId,
  allLabel,
  parentNotSelectable = false,
  onTaxonomySelected,
  selectedItemType = 'id',
  propId,
  onFocus,
  id,
  width,
  isQueryBuilder = false,
}) => {
  const taxonomyOptions =
    useMemo(
      () =>
        isQueryBuilder
          ? getTaxonomyListWithDefault(taxonomy, allLabel)
          : taxonomy,
      [isQueryBuilder, taxonomy, allLabel]
    ) ?? [];

  return (
    <TreeSelection
      id={id}
      data-test="taxonomy-select"
      selectedOptionId={selectedOptionId}
      options={taxonomyOptions}
      dropdownPosition="right"
      showAllOption={false}
      width={width}
      setLargeMinWidth
      parentNotSelectable={parentNotSelectable}
      disabled={!(taxonomy.length > 0)}
      onItemSelected={onTaxonomySelected}
      selectedItemType={selectedItemType}
      onFocus={onFocus}
      propId={propId}
    />
  );
};
